"use client"

import { Edit2, Trash2 } from "lucide-react"
import { Button } from "../../../components/ui/button"
import { Card } from "../../../components/ui/card"
import type { Kit } from "./categories"

type KitGridProps = {
  kits: Kit[]
  onEdit: (kit: Kit) => void
  onDelete: (id: string) => void
}

export function KitGrid({ kits, onEdit, onDelete }: KitGridProps) {
  if (kits.length === 0) {
    return (
      <Card className="border-dashed bg-card/50 p-12 text-center">
        <p className="text-lg text-muted-foreground">Nenhum kit cadastrado. Clique em "Novo Kit" para adicionar.</p>
      </Card>
    )
  }

  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {kits.map((kit) => (
        <Card key={kit.id} className="group overflow-hidden bg-card transition-all hover:border-primary/50">
          <div className="relative aspect-square overflow-hidden bg-muted">
            <img
              src={kit.thumb || "/placeholder.svg?height=400&width=400&query=sports kit"}
              alt={kit.name}
              className="h-full w-full object-cover transition-transform group-hover:scale-105"
            />
            <div className="absolute right-2 top-2 flex gap-2 opacity-0 transition-opacity group-hover:opacity-100">
              <Button
                size="icon"
                variant="secondary"
                onClick={() => onEdit(kit)}
                className="h-8 w-8 bg-background/90 backdrop-blur-sm hover:bg-background"
              >
                <Edit2 className="h-4 w-4" />
              </Button>
              <Button
                size="icon"
                variant="secondary"
                onClick={() => onDelete(kit.id)}
                className="h-8 w-8 bg-background/90 backdrop-blur-sm hover:bg-destructive hover:text-destructive-foreground"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </div>
          <div className="p-4">
            <h3 className="font-sans text-lg font-semibold text-foreground">{kit.name}</h3>
            <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{kit.description}</p>
            <div className="mt-3 flex gap-2">
              <div className="rounded-md bg-primary/10 px-2 py-1">
                <span className="text-xs font-medium text-primary">R$ {kit.price1.toFixed(2)}</span>
              </div>
              <div className="rounded-md bg-primary/10 px-2 py-1">
                <span className="text-xs font-medium text-primary">R$ {kit.price2.toFixed(2)}</span>
              </div>
              <div className="rounded-md bg-primary/10 px-2 py-1">
                <span className="text-xs font-medium text-primary">R$ {kit.price3.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  )
}